export enum ClientStatusTypes{
    ACTIVE = 1,
    DELETED = 2,
    INACTIVE = 3,
}